import { sendLaunchDarklyMetric } from './launchdarkly-track';

/**
 * Header nav dropdowns (Student accommodation A/B test + Student blog city guides)
 */

(function () {
  const dropdownConfigs = [
    {
      triggerId: 'student-accommodation-nav-trigger',
      menuId: 'student-accommodation-nav-dropdown',
      clickHref: '/student-accommodation',
      trackAccommodationDropdown: true,
    },
    {
      triggerId: 'student-accommodation-nav-trigger-mobile',
      menuId: 'student-accommodation-nav-dropdown-mobile',
      clickHref: '/student-accommodation',
      trackAccommodationDropdown: true,
    },
    {
      triggerId: 'student-blog-nav-trigger',
      menuId: 'student-blog-nav-dropdown',
      clickHrefAttr: 'data-primary-href',
      trackAccommodationDropdown: false,
    },
    {
      triggerId: 'student-blog-nav-trigger-mobile',
      menuId: 'student-blog-nav-dropdown-mobile',
      clickHrefAttr: 'data-primary-href',
      trackAccommodationDropdown: false,
    },
    {
      triggerId: 'student-blog-nav-trigger-mobile-header',
      menuId: 'student-blog-nav-dropdown-mobile-header',
      clickHrefAttr: 'data-primary-href',
      trackAccommodationDropdown: false,
    },
    {
      triggerId: 'letting-agents-nav-trigger',
      menuId: 'letting-agents-nav-dropdown',
      trackAccommodationDropdown: false,
    },
    {
      triggerId: 'letting-agents-nav-trigger-mobile-header',
      menuId: 'letting-agents-nav-dropdown-mobile-header',
      trackAccommodationDropdown: false,
    },
  ];

  dropdownConfigs.forEach(function (cfg) {
    const trigger = document.getElementById(cfg.triggerId);
    const menu = document.getElementById(cfg.menuId);
    if (trigger && menu) {
      const clickHref = cfg.clickHrefAttr
        ? trigger.getAttribute(cfg.clickHrefAttr) || trigger.getAttribute('href')
        : cfg.clickHref;
      initDesktopDropdown(
        trigger,
        menu,
        clickHref,
        cfg.trackAccommodationDropdown
      );
    }
  });

  // Track mobile menu link clicks (for the expandable mobile menu)
  const mobileMenuLinks = document.querySelectorAll(
    '[data-action="triggerStudentAccommodationMenu"] + ul [data-track-event]'
  );
  mobileMenuLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      const eventType = link.getAttribute('data-track-event');
      if (eventType) {
        trackLinkClick(eventType);
      }
    });
  });

  const trackEvent = function (eventName, data = {}, transport = 'beacon') {
    sendLaunchDarklyMetric(
      eventName,
      {
        ...data,
        test_name: 'student_accommodation_nav_dropdown_test',
      },
      { transport }
    );

    if (window.gtag && typeof window.gtag === 'function') {
      window.gtag('event', eventName, {
        event_category: 'Navigation',
        event_label: 'Student Accommodation Dropdown',
      });
    }
  };

  const trackDropdownView = function () {
    trackEvent('nav_dropdown_viewed', {}, 'axios');
  };

  const trackLinkClick = function (eventType) {
    trackEvent(eventType, {}, 'beacon');
  };

  function initDesktopDropdown(trigger, menu, clickHref, trackAccommodationDropdown) {
    const wrapper = trigger.parentElement;
    let closeTimeout = null;
    const hoverCloseDelay = 150;

    const openDropdown = function () {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
      menu.classList.remove(
        'tw-invisible',
        'tw-opacity-0',
        '-tw-translate-y-1'
      );
      trigger.setAttribute('aria-expanded', 'true');
      if (trackAccommodationDropdown) {
        trackDropdownView();
      }
    };

    const closeDropdown = function () {
      menu.classList.add('tw-invisible', 'tw-opacity-0', '-tw-translate-y-1');
      trigger.setAttribute('aria-expanded', 'false');
    };

    wrapper.addEventListener('mouseenter', function () {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
      openDropdown();
    });

    wrapper.addEventListener('mouseleave', function () {
      closeTimeout = setTimeout(function () {
        closeDropdown();
        closeTimeout = null;
      }, hoverCloseDelay);
    });

    trigger.addEventListener('click', function () {
      if (trackAccommodationDropdown) {
        trackEvent('nav_dropdown_student_accommodation_clicked', {}, 'beacon');
      }

      if (clickHref) {
        window.location.href = clickHref;
      }
    });

    document.addEventListener('click', function (e) {
      if (
        menu &&
        trigger &&
        !menu.contains(e.target) &&
        !trigger.contains(e.target)
      ) {
        closeDropdown();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.classList.contains('tw-invisible')) {
        closeDropdown();
        trigger.focus();
      }
    });

    const dropdownLinks = menu.querySelectorAll('[data-track-event]');
    dropdownLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        const eventType = link.getAttribute('data-track-event');
        if (eventType) {
          trackLinkClick(eventType);
        }
      });
    });
  }
})();
